export const CURRENCY_CODE = 'EUR';
export const COUNTRY_CODE = 'DE';

import {brandName} from "@/vendor/qconstants";

//merchant ID can be founde here: https://developer.apple.com/account/resources/identifiers/list/merchant
export const merchantIdentifier = "merchant.tipsiolive.de";
export const merchantDisplay = '' + brandName;
export const paymentRequestApi = true;

export const supportedNetworks = ["masterCard", "visa", 'vPay', 'amex', 'discover', 'maestro', 'jcb'];
export const merchantCapabilities = ["supports3DS", "supportsCredit", "supportsDebit"];
export const APPLE_PAY_VERSION_NUMBER = 3;

export function transfromOrderToApple(order) {

}


// const cartData = {
//   currency: "€",
//   currencyCode: "EUR",
//   products: [
//     {
//       id: 1,
//       name: "Apple",
//       url: "https://images.pexels.com/photos/39803/pexels-photo-39803.jpeg",
//       amount: 1.2,
//     },
//     {
//       id: 2,
//       name: "Orange",
//       url: "https://images.pexels.com/photos/42059/citrus-diet-food-fresh-42059.jpeg",
//       amount: 0.2,
//     },
//   ],
// };
